export const REVIEWER_ACTIONS = {
    SET_REVIEWER: "SET_REVIEWER",
    SET_IS_LOADING: "SET_IS_LOADING",
}